import React, { useContext, useEffect, useState } from "react";
import './CartTotal.css';
import { Link } from "react-router-dom";
import { ShopContext } from "../../context/ShopContext";
import { formatPrice } from "../../utils/formatPrice";


const CartTotal = () => {

    const {
        getTotalCartAmount,
        getTotalAmount,
        updateDeliveryCharge,
        orderDetails,
        all_product,
        cartItems,
        removeFromCart
    } = useContext(ShopContext);

    const [selectedValue, setSelectedValue,] = useState("pickup");
    const [deliveryMethod, setDeliveryMethod,] = useState("Free");
    //const [orderInfo, setOrderInfo,] = useState(orderDetails + deliveryMethod);

    const handleRadioChange = (value) => {
        setSelectedValue(value);
        updateDeliveryMethod(value)
    };

    const updateDeliveryMethod = (value) => {
        if (value === "pickup") {
            setDeliveryMethod("Free");
            updateDeliveryCharge(0);
            //setOrderInfo(orderDetails + "Free" + "~" + getTotalAmount());
        } else {
            setDeliveryMethod(formatPrice(5.00));
            updateDeliveryCharge(5.00);
            //setOrderInfo(orderDetails + "Delivery" + "~" + getTotalAmount());
        }
    }

    useEffect(() => {
        // Update delivery method based on context value - to avoid page refresh issue
    });

    return (
        <>
            <div className="carttotal">
                <hr />
                <h1>Cart Totals</h1>
                <div>
                    <div className="carttotal-item">
                        <p>Subtotal</p>
                        <p>{formatPrice(getTotalCartAmount())}</p>
                    </div>

                    <div className="carttotal-item">
                        <div className="carttotal-delivery">
                            <div className="carttotal-delivery-method">
                                <input type="radio" name="pickup"
                                    checked={
                                        selectedValue ===
                                        "pickup"
                                    }
                                    onChange={() =>
                                        handleRadioChange(
                                            "pickup"
                                        )
                                    }
                                />
                                <span>Pickup</span>
                            </div>
                            <div className="carttotal-delivery-method">
                                <input type="radio" id="delivery"
                                    checked={
                                        selectedValue ===
                                        "delivery"
                                    }
                                    onChange={() =>
                                        handleRadioChange(
                                            "delivery"
                                        )
                                    }
                                />
                                <span>Delivery</span>
                            </div>
                        </div>
                        <div>
                            <span id="delivery-charge">{deliveryMethod}</span>
                        </div>
                    </div>

                    <hr />
                    <div className="carttotal-item">
                        <h3>Total</h3>
                        <h3>{formatPrice(getTotalAmount())}</h3>
                    </div>
                </div>
                <Link to={"https://wa.me/14249778995?text=" + orderDetails}>
                    <button className="ordernow-button">
                        ORDER NOW!
                    </button>
                </Link>
            </div >
        </>
    )

}

export default CartTotal;